import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import styles from '../../tractionAI.module.scss';
import TypingText from "modules/tractionAI/components/typingText";
import ScoutItemResponse from "modules/tractionAI/screens/scout/scoutItemResponse";

const TractionAIScout = () => {
  const scrollableDivRef = useRef(null);

  const {
    tractionAiReducer: { scout }
  } = useSelector((state) => state);

  useEffect(() => {
    document.getElementById('bottomAI').scrollIntoView();
  }, []);

  useEffect(() => {
    if (scout.fetching && scrollableDivRef?.current) {
      document.getElementById('bottomAI').scrollIntoView({
        behavior: 'instant'
      });
    }
    if (!scout.fetching && scrollableDivRef?.current) {
      document.getElementById('bottomAI').scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [scout.fetching, scout.data, scrollableDivRef]);

  return (
    <div ref={scrollableDivRef}>
      {/*<h4 className="mb-3">Create a Scout Report</h4>*/}
      <div className={`d-flex w-100 flex-column mb-4 ${styles.resultsWrapper}`}>
        {
          (!scout.data?.length && !scout.fetching) ? (
            <div className="mb-5 mt-5 d-flex align-items-center justify-content-center">
              <TypingText
                text="Traction AI: “Please answer the following questions in as much detail as possible. The more information you provide, the better my answers will be."
              />
            </div>
          ) : null
        }
        <div className="d-flex flex-column">
          {
            scout.data.map((item, index) => (
              <ScoutItemResponse key={index} item={item} index={index} />
            ))
          }
        </div>
      </div>
    </div>
  );
};

export default React.memo(TractionAIScout);
